import React, { useContext, useState } from "react";
import { RolePermissions, PermissionContext } from "appContext";
import { checkPermission } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import StatusChangeDialog from "./StatusChangeDialog";
import ToggleSwitch from "./ToggleSwitch"; // new reusable toggle
import { pages } from "views/pages/manage/common/constant";

const StatusAToggleComponent = ({
  params,
  toggleStatusHandler = () => {},
  rowForm,
  rowFormHandler = () => {},
}) => {
  const userPermissions = RolePermissions(
    useContext(PermissionContext),
    pages["scholarshipConfig"]["id"]
  );
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const hasUpdate = checkPermission(userPermissions, "U");
  const value =
    params?.api.getRowMode(params.id) === "view"
      ? params.value
      : rowForm.status;
  const onToggleClick = () => setIsDialogOpen(true);

  return (
    <>
      <ToggleSwitch
        checked={value === "ACTIVE"}
        onClick={hasUpdate ? onToggleClick : undefined}
        disabled={!hasUpdate}
      />
      <StatusChangeDialog
        open={isDialogOpen}
        setOpen={setIsDialogOpen}
        rowData={
          params?.api.getRowMode(params.id) === "view" ? params.row : rowForm
        }
        onAgree={() => {
          
          if (params?.api.getRowMode(params.id) === "view") {
            toggleStatusHandler(params.row);
          } else {
            const newStatus =
              rowForm.status === "ACTIVE" ? "INACTIVE" : "ACTIVE";
            rowFormHandler(newStatus, "status");
          }
        }}
      />
    </>
  );
};

export default StatusAToggleComponent;
